import axios from 'axios'

const API_PATH = 'api/v2/admins/merchants/inbounds/curations'

const MerchantInboundCurationApiV2 = {
  /**
   * Schedule particular `Merchant::Inbound`
   *
   * Invoke `POST api/v2/admins/merchant/inbounds/receive`
   * @param {number} merchant_inbound_curation.id - Merchant Inbound Curation ID
   */
  physical_curated: async ({
    id
  }) =>  {
    const path = `${API_PATH}/${ id }/physical_curated`

    const response = axios.patch(path)
    return response
  }

}

export default MerchantInboundCurationApiV2
